<template>
  <div class="ml-center md:ml-center lg:ml-0 lg:container sliderMobile">

      <div class="sliderPoMobile mb-20 lg:mb-60">

        <h2 class="title-default mb-20 lg:mb-40">Sélectionnez un mobile</h2>

        <div class="splide mb-20" aria-label="Slider choix mobile à tarif exclusif">
          <div class="splide__track py-30">

            <ul class="splide__list">

                <li v-for="(mobile, index) in data_etape1.mobiles" :key="index" class="splide__slide item relative">
                  <span v-if="mobile.field_texte_home_encart" class="jumperSimple absolute top-0 left-0">{{ mobile.field_etiquette_mobile }}</span>
                  <span class="jumper5g w-60 absolute top-0 right-0 gradient-blue"><span>5G</span></span>
                  <div class="bg-white c-black pt-30 pb-20 px-20">


                    <div v-if="mobile.field_visuel[0]" class="dflex justify-center">
                      <img
                        :src="mobile.field_visuel[0].src"
                        :alt="mobile.field_visuel[0].alt"
                      />
                    </div>

                    <div class="mb-15">
                      <p class="text-sm text-bold leading-20 c-grey11">{{ mobile.field_marque}}</p>
                      <p class="text-bold lg:text-xl leading-22 lg:leading-24 mb-10 lg:mb-15">{{ mobile.title}}</p>
                    </div>

                    <div class="mb-20">
                      <span class="dflex items-center gap-5">
                        <span class="font-medium">à partir de </span>
                        <div class="infoToolTip">
                          <button class="pointer dflex" type="button" aria-expanded="false" aria-controls="toolTip-apartir1">
                            <span class="w-20 h-20 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M12.1337 7.5774a3.1035 3.1035 0 0 1-.5586.7528c-.2158.2112-.603.5667-1.1619 1.0664a4.7037 4.7037 0 0 0-.3712.3715 1.5288 1.5288 0 0 0-.208.2927 1.4627 1.4627 0 0 0-.1055.2659c-.025.0886-.0625.2442-.1123.4669-.0863.4723-.3564.7086-.811.7086-.2363 0-.4349-.0774-.5964-.2318-.1612-.1543-.2417-.3839-.2417-.6881 0-.3818.059-.7122.177-.9915.1127-.2709.2717-.52.4705-.736.1952-.2113.4585-.4621.7904-.7534.2904-.2541.5007-.4458.6302-.5753a1.9588 1.9588 0 0 0 .327-.4327 1.0477 1.0477 0 0 0 .1331-.518c0-.3633-.1351-.67-.4058-.9199-.2701-.2498-.6188-.3747-1.0456-.3747-.5 0-.8678.1262-1.104.378-.236.2524-.436.6236-.5994 1.1142-.1547.5134-.448.77-.8793.77-.2544 0-.469-.0895-.644-.269-.1746-.1793-.2622-.3735-.2622-.5825 0-.4314.1386-.8686.4157-1.3117.277-.4428.6812-.8097 1.2129-1.1004.5316-.2908 1.1514-.4362 1.86-.4362.6587 0 1.2402.1213 1.7444.3646.5043.2432.8938.5736 1.1687.9915.2748.4177.4124.8719.4124 1.3627 0 .386-.0785.7244-.2351 1.0154h-.0003Zm-2.5446 6.3098a1.0372 1.0372 0 0 1-.7087.2727 1.0739 1.0739 0 0 1-.7257-.2694c-.2069-.1795-.3105-.4304-.3102-.7531 0-.2862.1-.5269.2996-.7221.1998-.1953.4453-.293.7363-.293.2862 0 .5271.0975.7221.293.1955.1952.2933.4359.2933.7221 0 .3181-.1026.568-.3067.7498ZM9 .875C4.5127.875.875 4.5127.875 9c0 4.487 3.6377 8.125 8.125 8.125 4.4873 0 8.125-3.638 8.125-8.125C17.125 4.5127 13.4873.875 9 .875Z" clip-rule="evenodd"/></svg></span>
                          </button>
                          <div v-for="(forfait, index) in data_etape1.forfaits" id="toolTip-apartir1" class="infoToolTip__content richContent c-black">
                            <p>Prix du mobile valable avec le forfait {{ forfait.field_internet }}Go configuré dans votre Pack Open, avec engagement 12 mois.</p>
                          </div>
                        </div>
                      </span>
                      <span class="dflex items-baseline gap-5">
                        <span class="c-orange text-35 text-bold">{{ Number(mobile.field_prix_elite).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                        <span class="line-through c-grey11 text-bold">{{ Number(mobile.field_prix_card).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>
                        <span class="ml-auto dflex items-center gap-5">
                          <span class="text-bold">DAS</span>
                          <div class="infoToolTip posLeft posLeft--noFit">
                            <button class="pointer dflex" type="button" aria-expanded="false" aria-controls="toolTip-das1">
                              <span class="w-20 h-20 c-greyLight"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M12.1337 7.5774a3.1035 3.1035 0 0 1-.5586.7528c-.2158.2112-.603.5667-1.1619 1.0664a4.7037 4.7037 0 0 0-.3712.3715 1.5288 1.5288 0 0 0-.208.2927 1.4627 1.4627 0 0 0-.1055.2659c-.025.0886-.0625.2442-.1123.4669-.0863.4723-.3564.7086-.811.7086-.2363 0-.4349-.0774-.5964-.2318-.1612-.1543-.2417-.3839-.2417-.6881 0-.3818.059-.7122.177-.9915.1127-.2709.2717-.52.4705-.736.1952-.2113.4585-.4621.7904-.7534.2904-.2541.5007-.4458.6302-.5753a1.9588 1.9588 0 0 0 .327-.4327 1.0477 1.0477 0 0 0 .1331-.518c0-.3633-.1351-.67-.4058-.9199-.2701-.2498-.6188-.3747-1.0456-.3747-.5 0-.8678.1262-1.104.378-.236.2524-.436.6236-.5994 1.1142-.1547.5134-.448.77-.8793.77-.2544 0-.469-.0895-.644-.269-.1746-.1793-.2622-.3735-.2622-.5825 0-.4314.1386-.8686.4157-1.3117.277-.4428.6812-.8097 1.2129-1.1004.5316-.2908 1.1514-.4362 1.86-.4362.6587 0 1.2402.1213 1.7444.3646.5043.2432.8938.5736 1.1687.9915.2748.4177.4124.8719.4124 1.3627 0 .386-.0785.7244-.2351 1.0154h-.0003Zm-2.5446 6.3098a1.0372 1.0372 0 0 1-.7087.2727 1.0739 1.0739 0 0 1-.7257-.2694c-.2069-.1795-.3105-.4304-.3102-.7531 0-.2862.1-.5269.2996-.7221.1998-.1953.4453-.293.7363-.293.2862 0 .5271.0975.7221.293.1955.1952.2933.4359.2933.7221 0 .3181-.1026.568-.3067.7498ZM9 .875C4.5127.875.875 4.5127.875 9c0 4.487 3.6377 8.125 8.125 8.125 4.4873 0 8.125-3.638 8.125-8.125C17.125 4.5127 13.4873.875 9 .875Z" clip-rule="evenodd"/></svg></span>
                            </button>
                            <div id="toolTip-das1" class="infoToolTip__content richContent c-black">
                              <p>
                                <template v-if="mobile.field_das_tete">
                                  DAS tête : {{ mobile.field_das_tete }} W/Kg,<br>
                                </template>
                                <template v-if="mobile.field_das_tronc">
                                  DAS tronc : {{ mobile.field_das_tronc }} W/Kg,<br>
                                </template>
                                <template v-if="mobile.field_das_membres">
                                  DAS Membres : {{ mobile.field_das_membres }} W/Kg,<br>
                                </template>
                              </p>
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>


                    <div class="text-center">
                      <a v-if="mobile.field_lien_boutique && mobile.field_lien_boutique[0]" :href="mobile.field_lien_boutique[0].url" target="_blank" @click="taggage('carte_mobile', 'voir_en_detail', (mobile.field_marque + '_' + mobile.title).replace(/\s+/g, '_'), { tealium_event: 'select_content' })" class="jsModaleBtn block underline hover:no-underline font-bold text-sm py-10 w-full pointer">Voir en détail</a>
                      <a v-else href="#" class="jsModaleBtn block underline hover:no-underline font-bold text-sm py-10 w-full pointer">&nbsp;</a>
                    </div>
                  </div>

                  <div class="border-t2-grey15">
                    <button @click="selectMobile($event);taggage('carte_mobile', 'choisir_ce_mobile', (mobile.field_marque + '_' + mobile.title).replace(/\s+/g, '_'), { tealium_event: 'select_content' })" :data-id="mobile.nid" class="chooseMobile bg-white hover:bg-orange c-black hover:c-white w-full h-50 text-center pointer text-bold" type="button">Choisir ce mobile</button>
                  </div>
                </li>
              </ul>
          </div>
        </div>

        <div class="dflex gap-5 justify-end items-center mb-40">
          <div class="infoToolTip posLeft">
            <button class="pointer dflex" type="button" aria-expanded="false" aria-controls="toolTip-seeAll">
              <span class="w-20 lg:w-26 h-20 lg:h-26 c-blue2"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="currentColor" fill-rule="evenodd" d="M10.7702 13.4945H6.6838v-.4675l.096-.003c.2826-.0091.4925-.0893.6242-.2386.0468-.0539.1264-.2379.1264-.8563V7.8028c0-.5883-.0822-.81-.151-.8925-.0973-.116-.3-.1843-.6024-.2026l-.0932-.0057v-.4722h3.1783v5.6993c0 .5887.1536.8103.2223.8925.097.116.2848.1842.5926.2025l.0932.0055v.4649ZM8.5 2.5975c.7523 0 1.3621.6098 1.3621 1.362 0 .7524-.6098 1.3622-1.3621 1.3622-.7523 0-1.3621-.6098-1.3621-1.3621 0-.7523.6098-1.3621 1.3621-1.3621Zm0-1.8163C4.237.7813.7812 4.2371.7812 8.5S4.2371 16.2188 8.5 16.2188s7.7188-3.4559 7.7188-7.7188c0-4.263-3.4559-7.7188-7.7188-7.7188Z" clip-rule="evenodd"/></svg></span>
            </button>
            <div id="toolTip-seeAll" class="infoToolTip__content richContent c-black">
              <p>Les réductions liées à votre pack Open seront appliquées directement sur votre facture selon les conditions de l'offre et ne sont pas incluses dans les tarifs indiqués</p>
            </div>
          </div>
          <a @click="taggage('carte_mobile', 'voir_tous_les_mobiles', 'https://boutique.caraibe.orange.fr', { tealium_event: 'select_content' })" class="text-bold dflex hover:underline mr-15 lg:mr-0" href="https://boutique.caraibe.orange.fr" target="_blank">Voir tous les mobiles <span class="svg-18 w-18 dflex c-orange" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M7.482 14.344 12.937 9 7.482 3.656 5.924 5.182 9.82 9l-3.897 3.816 1.558 1.528Z"/></svg></span></a>
        </div>

      </div>
    </div>

    <div class="container">
      <div class="dflex dflex-col md:dflex-row justify-center gap-10 lg:gap-30">
        <button @click="resetMobile();taggage('configurateur_open', 'etape_1', 'annuler', { tealium_event: 'select_content' })" type="button" class="resetmobile btn btn--md btn--fill-light w-full lg:w-220">Annuler et passer aux choix des forfaits</button>
        <button @click="$emit('switchToEtape2');taggage('configurateur_open', 'etape_1', 'suivant', { tealium_event: 'select_content'});taggage('', '', '', { tealium_event: 'product_click', offre_id: [props.parcours.mobile], offre_marque: [data_etape1.mobiles[props.parcours.mobile].field_marque], offre_type: ['terminal'], offre_modele: [data_etape1.mobiles[props.parcours.mobile].title], offre_qte: [1], offre_libelle: [(data_etape1.mobiles[props.parcours.mobile].field_marque + '_' + data_etape1.mobiles[props.parcours.mobile].title).replace(/\s+/g, '_')], offre_prix_ttc: [data_etape1.mobiles[props.parcours.mobile].field_prix_elite]})" type="button" class="nextmobile btn btn--md btn--fill-dark w-full order-first lg:order-last lg:w-170" :disabled="!isEnabled">Suivant</button>
      </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';
import { taggage } from '@/utils/taggage.js';

const data_etape1 = ref({});
const error_etape1 = ref(null);

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});


const isEnabled = ref(false) // false = désactivé, true = activé

function enableSelect() {
  isEnabled.value = true
}

//defineEmits(['switchToEtape2']);
const emit = defineEmits(['switchToEtape2','incrementRecapKey']);


onMounted(async () => {
  try {
    const res = await fetch(`/packopenv3/etape1`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_etape1.value = await res.json();
    await nextTick();
    slidersPoMobile();
    const sliderMobile = document.querySelector('.sliderMobile')
    if (sliderMobile) {
      sliderMobile.scrollIntoView({
        behavior: 'smooth',  // défilement fluide
        block: 'start'       // aligne en haut de la fenêtre
      })
    }
    if (props.parcours.mobile != 0) {
      //console.log('Mobile Existe');
      const bouton = document.querySelector('.chooseMobile[data-id="' + props.parcours.mobile + '"]');
      //console.log(bouton);
      if (bouton) {
        bouton.click();
      }
    }
  } catch (e) {
    error_etape1.value = e.message;
  }
});

function selectMobile(event) {
  var mobile = event.target;
  enableSelect();
  mobile.classList.remove("bg-white","c-black");
  mobile.classList.add("bg-orange", "c-white");
  const liParent = mobile.closest('li');
  if (liParent) {
    liParent.classList.add("isSelected");
  }
  mobile.textContent = "Mobile sélectionné";
  props.parcours.mobile = mobile.dataset.id;
  //console.log('Parcours Mobile:'+props.parcours.value);
  emit('incrementRecapKey'); // informe le parent

  const buttons = document.querySelectorAll('.chooseMobile');
  buttons.forEach(btn => {
    if (btn !== mobile) {
      btn.classList.remove('bg-orange','c-white','bg-white','c-black'); // supprime 'toto' sur tous les autres
      btn.classList.add("bg-white", "c-black");
      btn.textContent = "Choisir ce mobile";
      const liParentOther = btn.closest('li');
      if (liParentOther) {
        liParentOther.classList.remove("isSelected");
      }
    }
  });
}


function resetMobile() {

  const buttons = document.querySelectorAll('.chooseMobile');
  buttons.forEach(btn => {
      btn.classList.remove('bg-orange','c-white','bg-white','c-black'); // supprime 'toto' sur tous les autres
      btn.classList.add("bg-white", "c-black");
      btn.textContent = "Choisir ce mobile";
      const liParentOther = btn.closest('li');
      if (liParentOther) {
        liParentOther.classList.remove("isSelected");
      }
      props.parcours.mobile = 0;
  });
  props.parcours.mobile = 0;
  emit('switchToEtape2');
}

</script>
